import { DataSource } from '@angular/cdk/collections';
import { Injectable, inject } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { FlashyFileService } from '@flashy/store/file';
import { IFlashyUiImageFile, IFlashyUiProduct } from '@flashy/store/products';

@Injectable({
  providedIn: 'root',
})
export abstract class FlashyUiModalHelperUri {
  readonly fileService = inject(FlashyFileService);

  abstract searchQuery$: Subject<{
    q: string;
    catalog: number | null;
    category: number | null;
    variant: string | null;
    stock: string | null;
  }>;

  destroy(): void {
    // Emits a reset sentinel; the param type is intentionally bypassed here.
    this.searchQuery$.next(null as never);
  }

  searchProducts(
    q: string,
    catalog: number | null,
    category: number | null,
    variant: string | null,
    stock: string | null
  ): void {
    this.searchQuery$.next({ q, catalog, category, variant, stock });
  }

  updateImageFile(file: IFlashyUiImageFile): Observable<IFlashyUiImageFile> {
    return of(file);
  }

  searchImageFile(q: string): void {
    this.searchQuery$.next({
      q,
      catalog: null,
      category: null,
      variant: null,
      stock: null,
    });
  }

  uploadImageFiles(files: File[]): Observable<IFlashyUiImageFile[]> {
    const formData = new FormData();
    for (const file of files) {
      formData.append('file[]', file);
    }
    return this.fileService.upload(formData).pipe(
      tap(() => this.searchImageFile('')) // Update files list
    );
  }

  deleteImageFile(file: IFlashyUiImageFile): Observable<boolean> {
    return this.fileService.delete(file).pipe(
      tap(() => this.searchImageFile('')), // Update files list
      map(() => true)
    );
  }

  abstract getProducts(): Observable<DataSource<IFlashyUiProduct>>;

  abstract getImageFiles(): Observable<DataSource<IFlashyUiImageFile>>;
}
